import $ from "jquery";
import f from "../../funcs";
import Events from "../Events";

import Backbone from "backbone";

import Icons from "./model/Icons";
import IconsView from "./view/IconsView";
import ContextMenuView from "../ContextMenuView";
import DesktopApi from "../api/DesktopApi";
import WallpapersModal from "../Wallpapers/WallpapersModal";
import langDictionary from "../lang/init";
import FilesApi from "../api/FilesApi";
import DragDrop from "../DragDrop";
import RowsStorage from "../storage/RowsStorage";
import Loader from "../Loader";
import "plugins/filesDrop";
import "css!classes/desktop/view/css/style";


let SYS_FILES = RowsStorage.get("SYS_FILES");

let Desktop = f.CreateClass("Desktop", {
    offsetTop: 0,
    offsetLeft: 72,
    background: {
        image: false
    }
}, Events);

let deskId = 0;
let iconIndex = 0;
function newIconId() {
    let time = Date.now();
    iconIndex++;
    return time + "" + iconIndex;
}

Desktop.prototype.init = function(params) {
    params = params || {};

    this.id = params.id || deskId++;

    this.initBox(params);
    this.initIcons(params);
    this.initContextMenu();
    this.api = new DesktopApi({
        desktop: this
    });

    this.load(function() {
        this.listenTo(this.icons, "dragStop reset add delete remove rename", this.save);
        this.draw();
        this.trigger("ready");
    }.bind(this));
};

Desktop.prototype.initIcons = function(params) {
    this.icons = new Icons(params.icons);
    this.iconsView = new IconsView({
        collection: this.icons,
        desktop: this,
        el: this.box
    });
};

Desktop.prototype.initBox = function(params) {
    f.initBox.call(this, params);
    this.$box.addClass("no-select tab-area");
    this.$box.data("tab-area", this);

    this.initSelectArea();
    this.$box.filesDrop(this);

    // с помощью класса DragDrop другие классы могут отправлять на рабочий стол иконки
    this.initCustomFilesDrop();
};

Desktop.prototype.initSelectArea = function() {
    // TODO: учитывать скролл рабочего стола
    this.$selectArea = $("<div class='desktop-select-area'></div>").appendTo(this.$box);

    this.$box.on("mousedown touchstart", function(e) {
        let target = e.target;
        if ( target != this.box ) {
            return;
        }

        let point = f.getMousePoint(e);
        let x = point.x - this.offsetLeft;
        let y = point.y - this.offsetTop;

        this._startSelect = { x, y };

        // если клик ровно по рабочему столу, а не по иконки,
        // то снимаем выделение со всех
        this.clearSelectIcons();
    }.bind(this));

    $(window).on("touchmove mousemove", function(e) {
        if ( !this._startSelect ) {
            return;
        }

        let point = f.getMousePoint(e);
        let x = point.x - this.offsetLeft;
        let y = point.y - this.offsetTop;
        let startPoint = this._startSelect;
        let dx = x - startPoint.x;
        let dy = y - startPoint.y;
        let left;
        let top;
        let width;
        let height;

        if ( dx < 0 ) {
            left = startPoint.x + dx;
            width = -dx;
        } else {
            left = startPoint.x;
            width = dx;
        }

        if ( dy < 0 ) {
            top = startPoint.y + dy;
            height = -dy;
        } else {
            top = startPoint.y;
            height = dy;
        }

        this.$selectArea.css({
            display: "block",
            left: left + "px",
            top: top + "px",
            width: width + "px",
            height: height + "px"
        });

        // выделяем иконки
        this.selectIconsByArea(left, top, width, height);
    }.bind(this));

    $(window).on("touchend mouseup", function() {
        this.$selectArea.get(0).style.display = "none";
        this._startSelect = false;
    }.bind(this));
};

Desktop.prototype.clearSelectIcons = function() {
    this.iconsView.children.each(function(view) {
        view.$el.removeClass("selected");
    });
};

// выделяем только те ячейки, которые попадают в область
Desktop.prototype.selectIconsByArea = function(x, y, w, h) {
    // средний размер иконки, точность пока не нужна
    let iw = 90;
    let ih = 110;

    this.iconsView.children.each(function(view) {
        view.$el.removeClass("selected");

        let ix = view.model.get("x");
        let iy = view.model.get("y");

        if (
            ix + iw > x
                && iy + ih > y

                && ix < x + w
                && iy < y + h
        ) {
            view.$el.addClass("selected");
        }
    }.bind(this));
};

Desktop.prototype.draw = function() {
    this.iconsView.render();
};

Desktop.prototype.getContextItems = function() {
    return [
        {
            name: langDictionary.get("change_desktop_wallpapers"),
            onClick: this.showChangeWallpapersModal.bind(this)
        }
    ];
};

Desktop.prototype.initContextMenu = function() {
    this.contextmenuCollection = new Backbone.Collection();
    this.contextmenuCollection.set(this.getContextItems());

    this.contextmenu = new ContextMenuView({
        icon: this,
        collection: this.contextmenuCollection,
        listenElem: this.box,
        touchOpenTimeout: 1500
    });
    this.contextmenu.render();
};

Desktop.prototype.load = function(callback) {
    if ( !f.isFunction(callback) ) {
        callback = function() {};
    }

    this.api.load(function(err, data) {

        // обратная совместимость
        if ( f.isArray(data) ) {
            data = {
                icons: data
            };
        }
        if ( !f.isObject(data) ) {
            data = {};
        }
        if ( !f.isArray(data.icons) ) {
            data.icons = [];
        }

        // определяем фон рабочего стола
        let image = {
            src: "/img/bg3.png"
        };

        let sysBg = false;
        if ( system.user.model.get("SYS_FILES_FILE_BG_URL") ) {
            sysBg = {
                src: system.user.model.get("SYS_FILES_FILE_BG_URL"),
                color: "white",
                position: "center center",
                repeat: "no-repeat"
            };

            let companyBgWidth = system.user.model.get("COMPANY_BG_WIDTH");
            let companyBgHeight = system.user.model.get("COMPANY_BG_HEIGHT");

            if ( companyBgWidth || companyBgHeight ) {
                if ( !companyBgHeight ) {
                    sysBg.size = companyBgWidth + "% auto";
                }
                else if ( !companyBgWidth ) {
                    sysBg.size = "auto " + companyBgHeight + "%";
                }
                else {
                    sysBg.size = companyBgWidth + "% " + companyBgHeight + "%";
                }
            }
        }

        if ( !sysBg ) {
            sysBg = system.options.get("desktop_bg");
            if ( f.isString(sysBg) ) {
                sysBg = { src: sysBg };
            }
        }

        let currentBg = data.background;
        if ( !currentBg ) {
            currentBg = sysBg;
        } else if ( !currentBg.isUserChoose ) {
            currentBg = sysBg;
        }
        image = currentBg || image;


        if ( f.isString(image) ) {
            image = {
                src: image
            };
        }

        this.background = image;

        this.$box.css({
            "background-image": "url(" + (f.normolizeURL(image.src) || image.image) + ")",
            "background-repeat": image.repeat || "",
            "background-position": image.position || "",
            "background-size": image.size || "",
            "background-color": image.color || "white"
        });


        let icons = data.icons;
        if ( icons.length === 0 ) {
            callback();
            return;
        }

        this.requirePlugins(icons.map(function(icon) {
            return icon.plugin;
        }), function() {
            this.icons.reset();
            this.icons.set(icons);
            callback();
        }.bind(this));

    }.bind(this));
};

Desktop.prototype.save = function(callback) {
    // обратная совместимость
    this.api.save({
        background: this.background,
        icons: this.icons.toJSON()
    }, callback);
};

Desktop.prototype.onFilesDrop = function(params) {
    let files = params.files;
    if ( !files ) {
        return;
    }
    this.loader = this.loader || new Loader({
        box: this.$box
    });
    this.loader.start();
    FilesApi.uploadToSysFolder({
        sysName: "desktop",
        files
    }, function(err, files) {
        this.loader.stop();

        if ( err || !files ) {
            return;
        }

        let point = f.getMousePoint(params.event.originalEvent);
        let x = Math.max(point.x - this.offsetLeft, 0);
        let y = Math.max(point.y - 15, 0);

        let plugins = [];
        let icons = files.map(function(file) {
            let icon = this.fileRow2icon(file, x, y);

            plugins.push(icon.plugin);

            return icon;
        }, this);

        this.requirePlugins(plugins, function() {
            this.icons.add(icons);
        }.bind(this));
    }.bind(this));
};

Desktop.prototype.fileRow2icon = function(file, x, y) {
    x = x || 0;
    y = y || 0;

    let icon = { id: newIconId() };

    icon.title = file.FILE_NAME;
    icon.plugin = this.getPluginByFile(file);
    if ( icon.plugin == "unknown" ) {
        icon.mask = "unknown";
    } else {
        icon.mask = file.FILE_EXT.toLowerCase();
    }

    icon.url = file.FILE_URL;
    icon.x = x;
    icon.y = y;
    icon.ID_SYS_FILES = file.ID;

    x += 150;
    if ( x >= this.box.offsetWidth ) {
        x -= 150;
        y += 150;
    }

    return icon;
};

Desktop.prototype.focusEnter = function($elem) {
    $elem.dblclick();
};

Desktop.prototype.getPluginByFile = function(file) {
    let ext = file.FILE_EXT.toLowerCase();

    if ( ext == "xls" || ext == "xlsx" || ext == "doc" || ext == "docx" ) {
        return "office-viewer";
    }

    if ( ext == "pdf" ) {
        return "iframe";
    }

    if ( ext == "jpg" || ext == "png" || ext == "gif" || ext == "bmp" || ext == "jpeg" ) {
        return "iframe";
    }

    if ( ext == "iframe" || ext == "chicken" ) {
        return "iframe";
    }

    return "unknown";
};

Desktop.prototype.getPluginPath = function(pluginName) {
    let file;
    switch (pluginName) {
        case "office-viewer":
            file = "OfficeViewer";
            break;
        case "settings":
            file = "Settings";
            break;
        case "image":
            file = "Image";
            break;
        case "iframe":
            file = "IframeView";
            break;
    }

    if ( file ) {
        return "classes/desktop/view/IconPlugin/" + file;
    } else {
        return false;
    }
};

Desktop.prototype.requirePlugins = function(plugins, callback) {
    let paths = plugins.map(this.getPluginPath, this)
        .filter(function(a) {
            return !!a;
        });

    if ( paths.length === 0 ) {
        return setTimeout(callback, 5);
    }
    require(paths, callback);
};

Desktop.prototype.add = function(icons) {
    let plugins = icons.map(function(icon) {
        return icon.plugin;
    });

    this.requirePlugins(plugins, function() {
        this.icons.add(icons);
    }.bind(this));
};


Desktop.prototype.showChangeWallpapersModal = function() {
    if ( this.wallpapersModal ) {
        this.wallpapersModal.show();
        return;
    }

    this.wallpapersModal = new WallpapersModal({
        title: langDictionary.get("wallpapers_modal_title")
    });
    this.wallpapersModal.show();

    this.wallpapersModal.on("hide", function() {
        this.wallpapersModal.destroy();
        this.wallpapersModal = null;
    }.bind(this));

    this.wallpapersModal.on("change", function(model) {
        this.setBg(model.attributes);
    }.bind(this));
};
Desktop.prototype.setBg = function(background, options) {
    options = f.deepMixin({ save: true }, options);

    this.background = background;
    background.isUserChoose = true;

    //map мне запили
    this.$box.css({
        "background-image": "url(" + f.normolizeURL(background.src) + ")",
        "background-repeat": background.repeat || "",
        "background-position": background.position || "",
        "background-size": background.size || "",
        "background-color": background.color || ""

    });

    if ( options.save ) {
        this.save();
    }
};

Desktop.prototype.initCustomFilesDrop = function() {
    this.customFilesDrop = new DragDrop();
    this.customFilesDrop.addElem(this.$box);

    this.listenTo(this.customFilesDrop, "start", function(e) {
        e.cancel();
    });

    this.listenTo(this.customFilesDrop, "dragover", function(e) {
        let desktopIconView = e.start.get("desktopIconView");
        if ( desktopIconView && this.icons.contains(desktopIconView.model) ) {
            return;
        }

        if ( !e.get("sysFiles") ) {
            return;
        }

        this.$box.addClass("files-drag-over");
    }.bind(this));

    this.listenTo(this.customFilesDrop, "dragout", function() {
        this.$box.removeClass("files-drag-over");
    }.bind(this));

    this.listenTo(this.customFilesDrop, "drop", function(e) {
        let desktopIconView = e.start.get("desktopIconView");
        if ( desktopIconView && this.icons.contains(desktopIconView.model) ) {
            e.start.dragDrop._document_onEnd(e.$event);
            e.start.cancel();
            return;
        }

        let sysFiles = e.get("sysFiles");
        if ( !sysFiles || !sysFiles.length ) {
            return;
        }

        // Проверка на дубликат, если имеется дубликат то для дубликата прописываюстя новые координаты
        if ( _checkDuplicate.call(this, sysFiles[0], e) ) {
            return;
        }

        let iterations = sysFiles.map(function(id) {
            return SYS_FILES.get_with(id);
        });
        f.parallel(iterations, function(err, models) {
            models = models || [];

            let icons = models.map(function(fileModel) {
                // TODO: сделать x, y сеткой, иначе все файлы в одном месте
                return this.fileRow2icon(fileModel.attributes, e.x - 50, e.y - 50);
            }.bind(this));

            let plugins = icons.map(function(icon) {
                return icon.plugin;
            });

            this.requirePlugins(plugins, function() {
                this.icons.add(icons);
            }.bind(this));

        }.bind(this));

    }.bind(this));
};

/***** PRIVATE METHODS *****/

/**
     * Проверяет иконку на дубликат, если такая иконка уже есть то для старой иконки будут указаны новые координаты
     *
     * @param {string} idIcon
     * @private
     */
function _checkDuplicate(idIcon, e) {
    let
        Desktop = this;
    let iconModel;
    let iconEl;

    // Поиск дубликата
    iconModel = _getIconModel(Desktop, idIcon);

    if ( iconModel ) { // если есть дубликат прописываем новую позицию для дубликата
        iconEl = Desktop.iconsView.children.findByModel(iconModel).el;
        return _setPosIcon.call(this, iconModel, iconEl.style, e);
    }
    else {// если дубликата нет, код работает как работал
        return false;
    }

}
function _getIconModel(Desktop, idIcon) {
    try {
        return Desktop.icons.findWhere({ ID_SYS_FILES: idIcon });
    } catch (e) {
        return console.warn("invalid params");
    }
}
function _setPosIcon(model, style, e) {
    let
        X = e.x - this.offsetLeft;
    let Y = e.y - this.offsetTop;

    model.set({ x: X, y: Y });
    style.top = Y + "px";
    style.left = X + "px";
    return true;
}


Desktop.IconView = IconsView.IconView;

export default Desktop;
